import { type PageContext } from 'vike/types'
const routeRegex = /((\/[^/]+)*)\/property\/([A-Za-z0-9-_]+)/
export function route(pageContext: PageContext) {
  const match = pageContext.urlPathname.match(routeRegex)
  if (!match) return false
  const [, path, , id] = match
  const mode = path.match(/^\/(buy|rent)/)?.[1] ?? 'buy'
  return {
    precedence: 3,
    routeParams: { mode, path: path.replace(/^\//, ''), place: path, id, subpath: '' }
  }
}
